import { useQuery } from '@tanstack/react-query'

import type { Account } from '../../types/account'
import api from '../../api'

const useSingleAccount = (
	accountRequestID: string,
	getTags: boolean = false,
	options?: { enabled?: boolean }
) => {
	const enabled =
		options?.enabled !== undefined
			? options.enabled
			: Boolean(accountRequestID && String(accountRequestID).trim())

	return useQuery({
		queryKey: ['accounts', accountRequestID, getTags],
		queryFn: () => api.accounts.getSingleAccount(accountRequestID, getTags),
		enabled,
		select(data) {
			if(data.body !== undefined) {
				const response = data.body[0]
				return response as Account
			} else {
				let response = {} as Account
				response["status"] = "ERROR"
				response["details"] = data
				return response
			}
		}
	})
}

export default useSingleAccount
